import { workspaceStore } from "../stores/WorkspaceStore";
import { useZoomStore } from "../stores/ZoomStore";
import { RydKeybindingTypes } from "./common";


export namespace ZoomKB {
    export type KeybindingHandlers = {
        increaseZoom: RydKeybindingTypes.VoidHandler,
        decreaseZoom: RydKeybindingTypes.VoidHandler
        resetZoom: RydKeybindingTypes.VoidHandler
    };

    export function create(): KeybindingHandlers {

        return {
            increaseZoom: () => {
                const old = workspaceStore.getState().uiState.zoomFactor;
                if (old <= 1) return;
                const newZoom = Math.floor(old * 0.9);
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, zoomFactor: newZoom });
                useZoomStore.getState().setZoomFactor(newZoom);
            },
            decreaseZoom: () => {
                const old = workspaceStore.getState().uiState.zoomFactor;
                const newZoom = old * 1.1;
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, zoomFactor: newZoom });
                useZoomStore.getState().setZoomFactor(newZoom);
            },
            resetZoom: () => {
                // FIXME: use PPQ from project
                const defaultZoom = 480;
                workspaceStore.getState().setUIState({ ...workspaceStore.getState().uiState, zoomFactor: defaultZoom });
                useZoomStore.getState().setZoomFactor(defaultZoom);
            }
        };
    }
}
